/*=========================================================================================
  File Name: moduleLanguage.js
  Description: Language Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleRegionState.js'
import mutations from './moduleRegionMutations.js'
import actions from './moduleRegionActions.js'
import getters from './moduleRegionGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations, 
    actions: actions,
    getters: getters
}
